/* eslint-disable react/no-danger */
import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Detector from '../../partials/Detector';
import petitImage from '../../../../img/employee/petit.svg';
import urbaniaImage from '../../../../img/employee/urbania.svg';

import styles from '../../../../styles/blocks/employee/main-title.module.scss';

const icons = {
    petit: petitImage,
    urbania: urbaniaImage,
};

const propTypes = {
    body: PropTypes.string,
    colors: PropTypes.shape({
        type: PropTypes.oneOf(['none', 'color', 'gradient']),
        colors: PropTypes.arrayOf(PropTypes.string),
    }),
    className: PropTypes.string,
};

const defaultProps = {
    body: null,
    colors: {
        type: 'none',
        colors: [],
    },
    className: null,
};

const MainTitleBlock = ({ body, colors, className }) => {
    const [visible, setVisible] = useState(false);

    const { type: colorType = null, colors: customColors = [] } = colors || {};
    const isGradient = colorType === 'gradient';

    const colorStyles = useMemo(() => {
        if (colorType === 'color') return { color: customColors[0] };
        if (colorType === 'gradient')
            return {
                backgroundImage: `linear-gradient(to bottom,  ${customColors[0]}, ${customColors[1]}, ${customColors[0]})`,
            };
        return null;
    }, [colorType, customColors]);

    const onEnter = useCallback(() => {
        setVisible(true);
    }, [setVisible]);

    return (
        <Detector onEnter={onEnter}>
            <div
                className={classNames([
                    styles.container,
                    {
                        [styles.visible]: visible,
                        [styles.animated]: isGradient,
                        [styles.isGradient]: isGradient,
                        [className]: className !== null,
                    },
                ])}
            >
                <div
                    className={styles.inner}
                    style={colorStyles}
                    dangerouslySetInnerHTML={{
                        __html: Object.keys(icons).reduce(
                            (currentBody, iconKey) =>
                                currentBody.replace(
                                    `:${iconKey}:`,
                                    `<div><img src="${icons[iconKey]}" /></div>`,
                                ),
                            body,
                        ),
                    }}
                />
                <div className={styles.line} style={colorStyles} />
            </div>
        </Detector>
    );
};

MainTitleBlock.propTypes = propTypes;
MainTitleBlock.defaultProps = defaultProps;

export default MainTitleBlock;
